"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Device = exports.genCounterAdd = exports.Subscriptions = void 0;
var Subscriptions;
(function (Subscriptions) {
    Subscriptions[Subscriptions["Unknown"] = 0] = "Unknown";
    Subscriptions[Subscriptions["Archived"] = 1] = "Archived";
    Subscriptions[Subscriptions["Beginner"] = 2] = "Beginner";
    Subscriptions[Subscriptions["Professional"] = 3] = "Professional";
    Subscriptions[Subscriptions["Unlimited"] = 4] = "Unlimited";
})(Subscriptions = exports.Subscriptions || (exports.Subscriptions = {}));
exports.genCounterAdd = (_a = {},
    _a[Subscriptions.Unknown] = 0,
    _a[Subscriptions.Archived] = 5,
    _a[Subscriptions.Beginner] = 3,
    _a[Subscriptions.Professional] = 10,
    _a[Subscriptions.Unlimited] = 10,
    _a);
var Device;
(function (Device) {
    Device["DESKTOP"] = "desktop";
    Device["MOBILE"] = "mobile";
})(Device = exports.Device || (exports.Device = {}));
